/** Link di condivisione: canonical pulito, UTM solo negli URL condivisi. */
import { canonicalBase } from "@/components/site/Seo";

export function articleUrl(slug) {
  return `${canonicalBase()}/diario-dal-borgo/${slug}`;
}

/** URL tracciato per piattaforma. Non entra mai in canonical né in sitemap. */
export function sharedUrl(slug, platform = "share") {
  const params = new URLSearchParams({
    utm_source: platform,
    utm_medium: "social",
    utm_campaign: "diario",
    utm_content: slug,
  });
  return `${articleUrl(slug)}?${params.toString()}`;
}

/** Didascalia pronta da incollare, con una frase reale dell'articolo. */
export function shareCaption(article, platform = "share") {
  // Lookahead invece di lookbehind: i lookbehind nelle regex non sono supportati da Safari < 16.4
  // e provocano un SyntaxError che blocca l'intero bundle su iOS.
  const excerpt = (article.excerpt || "").trim();
  const sentence = (excerpt.match(/^[\s\S]*?[.!?](?=\s|$)/)?.[0] || excerpt).trim();
  return [
    "Dal Diario di Osteria Aterrana",
    "",
    article.title,
    sentence && sentence !== article.title ? sentence : "",
    "",
    "Scopri cosa si dice nel nostro Diario, dal nostro sito ufficiale.",
    `Leggi l'articolo completo → ${sharedUrl(article.slug, platform)}`,
  ]
    .filter((line, i, all) => !(line === "" && all[i - 1] === ""))
    .join("\n");
}

export function facebookShareUrl(slug) {
  return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(sharedUrl(slug, "facebook"))}`;
}
